module.exports = __webpack_public_path__ + "media/images/university_logos/Keele-University-9d6c8e536750f347096d0f66164e0cca.svg";